import { LitElement as d, unsafeCSS as l } from "lit";
import { property as e } from "lit/decorators.js";
import c from "../../foundations/icon/icon.style.css.js";
import y from "../../shared/reset.style.css.js";
import { booleanType as s } from "../../utils/property-types.js";
import g from "./header-menu-patient.style.css.js";
import { headerMenuPatientTemplate as u } from "./header-menu-patient.template.js";
var m = Object.defineProperty, t = (p, i, n, b) => {
  for (var a = void 0, r = p.length - 1, h; r >= 0; r--)
    (h = p[r]) && (a = h(i, n, a) || a);
  return a && m(i, n, a), a;
};
class o extends d {
  constructor() {
    super(), this.disabled = !1, this.variant = "default", this.name = void 0, this.cip = void 0, this.age = void 0, this.ageLabel = void 0, this.gender = void 0, this.phoneMain = void 0, this.hasPhoneMainCall = !1, this.hasPhoneMainChat = !1, this.phoneAlt = void 0, this.hasPhoneAltCall = !1, this.hasPhoneAltChat = !1, this.mail = void 0, this.mailHref = void 0, this.address = void 0, this.addressURL = "#", this.infoLabel = "Dades del pacient", this.assignedLabel = "Professionals assignats", this.detailsLabel = "Veure més detalls", this.editLabel = "Editar usuari", this.hideViewDetails = !1, this.jcef = !1, this.edit = !1, this.assignments = void 0, this.hideCopyCip = !1, this.upLabel = "UP", this.upMessage = "Usuari desplaçat: no pertany a l’equip d’atenció primària", this.tooltipFixed = !1, this.tooltipPosition = "top", this._showDropdown = !1, this._toggleIcon = "expand_more", this._toggleLabel = "Obrir", this._handleDocumentClickBound = this._handleDocumentClick.bind(this);
  }
  static get styles() {
    return [l(y), l(c), l(g)];
  }
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("mousedown", this._handleDocumentClickBound);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("mousedown", this._handleDocumentClickBound);
  }
  _toggleDropdown() {
    this._showDropdown = !this._showDropdown, this._toggleIcon = this._showDropdown ? "expand_less" : "expand_more", this._toggleLabel = this._showDropdown ? "Tancar" : "Obrir", this.requestUpdate();
  }
  _handleViewDetails() {
    this._toggleDropdown(), this.dispatchEvent(
      new CustomEvent("onViewDetails", {
        bubbles: !1,
        composed: !1
      })
    );
  }
  _handleEdit() {
    this._toggleDropdown(), this.dispatchEvent(
      new CustomEvent("onEdit", {
        bubbles: !1,
        composed: !1
      })
    );
  }
  _handleCIPClick(i) {
    this._handleCopyCIP(i), this._toggleDropdown();
  }
  _handleCopyCIP(i) {
    i.stopPropagation(), this.cip && (navigator.clipboard.writeText(this.cip), this.dispatchEvent(
      new CustomEvent("onCopyCIP", {
        detail: { text: this.cip },
        bubbles: !0,
        composed: !0
      })
    ));
  }
  _handlePhoneCall(i) {
    this.dispatchEvent(
      new CustomEvent("phone-call", {
        detail: { phoneNumber: i },
        bubbles: !0,
        composed: !0
      })
    );
  }
  _handlePhoneChat(i) {
    this.dispatchEvent(
      new CustomEvent("phone-chat", {
        detail: { phoneNumber: i },
        bubbles: !0,
        composed: !0
      })
    );
  }
  _getGenderIcon() {
    var n;
    return ((n = this.gender) == null ? void 0 : n.toLowerCase()) === "femení" ? "female" : "male";
  }
  _handleDocumentClick(i) {
    this._clickedOutside(this, i);
  }
  _clickedOutside(i, n) {
    n.composedPath().includes(i) || this._showDropdown && this._toggleDropdown();
  }
  render() {
    return u(this);
  }
}
t([
  e(s)
], o.prototype, "disabled");
t([
  e({ type: String })
], o.prototype, "variant");
t([
  e({ type: String })
], o.prototype, "name");
t([
  e({ type: String })
], o.prototype, "cip");
t([
  e({ type: String })
], o.prototype, "age");
t([
  e({ type: String })
], o.prototype, "ageLabel");
t([
  e({ type: String })
], o.prototype, "gender");
t([
  e({ type: String })
], o.prototype, "phoneMain");
t([
  e(s)
], o.prototype, "hasPhoneMainCall");
t([
  e(s)
], o.prototype, "hasPhoneMainChat");
t([
  e({ type: String })
], o.prototype, "phoneAlt");
t([
  e(s)
], o.prototype, "hasPhoneAltCall");
t([
  e(s)
], o.prototype, "hasPhoneAltChat");
t([
  e({ type: String })
], o.prototype, "mail");
t([
  e({ type: String })
], o.prototype, "mailHref");
t([
  e({ type: String })
], o.prototype, "address");
t([
  e({ type: String })
], o.prototype, "addressURL");
t([
  e({ type: String })
], o.prototype, "infoLabel");
t([
  e({ type: String })
], o.prototype, "assignedLabel");
t([
  e({ type: String })
], o.prototype, "detailsLabel");
t([
  e({ type: String })
], o.prototype, "editLabel");
t([
  e(s)
], o.prototype, "hideViewDetails");
t([
  e(s)
], o.prototype, "jcef");
t([
  e(s)
], o.prototype, "edit");
t([
  e({ type: Array })
], o.prototype, "assignments");
t([
  e(s)
], o.prototype, "hideCopyCip");
t([
  e({ type: String })
], o.prototype, "upLabel");
t([
  e({ type: String })
], o.prototype, "upMessage");
t([
  e(s)
], o.prototype, "tooltipFixed");
t([
  e({ type: String })
], o.prototype, "tooltipPosition");
export {
  o as HeaderMenuPatient
};
//# sourceMappingURL=header-menu-patient.js.map
